import './styles.scss';

import logo from '../../../../images/kashable-logo-light.svg';

import React, {CSSProperties} from 'react';

import {HeaderItemLink, HeaderItemLinkMode} from './components/HeaderItemLink/HeaderItemLink';
import {HeaderNotifications} from './components/HeaderNotifications/HeaderNotifications';
import {AppHeaderMenuItem, HeaderUser} from './components/HeaderUser/HeaderUser';

import {Link, useHistory} from 'react-router-dom';

interface AppHeaderProps {
    items?: AppHeaderMenuItem[];
    withDashboard?: boolean;
    withNotifications?: boolean;
    style?: CSSProperties;
}

export const AppHeader = ({
    withDashboard = false,
    withNotifications = false,
    items = [],
    style,
}: AppHeaderProps) => {
    const history = useHistory();

    return (
        <header className='app-header' style={style}>
            <div className='app-header__wrap'>
                <Link
                    className='app-header__logo'
                    title='Return to Main Page'
                    aria-label='Return to Main Page'
                    to='/'>
                    <img alt='Kashable Logo' src={logo} />
                </Link>
                <nav className='app-header__navigation'>
                    {withDashboard && (
                        <div className='app-header__item'>
                            <HeaderItemLink
                                onClick={() => history.push('/home')}
                                mode={HeaderItemLinkMode.DASHBOARD}
                            />
                        </div>
                    )}
                    {withNotifications && (
                        <div className='app-header__item'>
                            <HeaderNotifications />
                        </div>
                    )}
                    <HeaderUser items={items} />
                </nav>
            </div>
        </header>
    );
};
